const __WEBPACK_NAMESPACE_OBJECT__ = flarum.core.compat['extensions/fof-forum-widgets-core/common/components/Widget'];